const getInitials = (name = '') => {
  if (!name.trim()) return 'NA'; // Default to 'NA' if name is empty or only spaces

  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((v) => v[0].toUpperCase())
    .join('');
};

export default getInitials;
